import { render, staticRenderFns } from "./ThemePreferences.vue?vue&type=template&id=3d25a4f2&scoped=true&"
import script from "./ThemePreferences.vue?vue&type=script&lang=js&"
export * from "./ThemePreferences.vue?vue&type=script&lang=js&"
import style0 from "./ThemePreferences.vue?vue&type=style&index=0&id=3d25a4f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d25a4f2",
  null
  
)

export default component.exports